<template>
  <div class="owner_menu">
    <el-menu
      @open="handleOpen"
      @close="handleClose"
      :default-active="this.$route.path"
      router
      class="menu"
    >
      <el-submenu index="/MyOwner">
        <template slot="title">
          <span slot="title">写手</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="/MyWriter">
            <div class="line"></div>
            <i class="iconfont icon-kehu"></i>
            <span slot="title">我的写手</span>
          </el-menu-item>
          <el-menu-item index="/OrderCenter">
            <div class="line"></div>
            <i class="iconfont icon-wp-sj"></i>
            <span slot="title">接单中心</span>
          </el-menu-item>
          <el-menu-item index="/WriterBookInfo">
            <div class="line"></div>
            <i class="iconfont icon-wp-sj"></i>
            <span slot="title">写手书籍信息</span>
          </el-menu-item>
          <el-menu-item index="/WriterHighSeas">
            <div class="line"></div>
            <i class="iconfont icon-gonghaiguanli"></i>
            <span slot="title">写手公海信息</span>
          </el-menu-item>
          <el-menu-item index="/UploadManuscript">
            <div class="line"></div>
            <i class="iconfont icon-kehuchazhong"></i>
            <span slot="title">每日上传稿件</span>
          </el-menu-item>
          <el-menu-item index="/ManuscriptManage">
            <div class="line"></div>
            <i class="iconfont icon-kehuchazhong"></i>
            <span slot="title">稿费预支及暂压稿</span>
          </el-menu-item>
          <el-menu-item index="/ManuscriptAdvance">
            <div class="line"></div>
            <i class="iconfont icon-kehuchazhong"></i>
            <span slot="title">稿费预支申请记录</span>
          </el-menu-item>
          <el-menu-item index="/ManuscriptTemporary">
            <div class="line"></div>
            <i class="iconfont icon-kehuchazhong"></i>
            <span slot="title">暂压稿费申请记录</span>
          </el-menu-item>
          <el-menu-item index="/writerFeeExpenditure">
            <div class="line"></div>
            <i class="iconfont icon-chuyuanjiesuan"></i>
            <span slot="title">其余费用支出</span>
          </el-menu-item>
          <el-menu-item index="/writerFeeIncome">
            <div class="line"></div>
            <i class="iconfont icon-chuyuanjiesuan"></i>
            <span slot="title">其余费用收入</span>
          </el-menu-item>
          <el-menu-item index="/ManuscriptDeposit">
            <div class="line"></div>
            <i class="iconfont icon-chuyuanjiesuan"></i>
            <span slot="title">压稿管理</span>
          </el-menu-item>
          <el-menu-item index="/UploadFileRecord">
            <div class="line"></div>
            <i class="iconfont icon-jilu"></i>
            <span slot="title">文件上传记录</span>
          </el-menu-item>
          <el-menu-item index="/writerCheaterPool">
            <div class="line"></div>
            <i class="iconfont icon-zongcejieguochakan"></i>
            <span slot="title">骗子库</span>
          </el-menu-item>
          <el-menu-item index="/InitPressManuscript">
            <div class="line"></div>
            <i class="iconfont icon-chuyuanjiesuan"></i>
            <span slot="title">初始压稿</span>
          </el-menu-item>
          <el-menu-item index="/ManuscriptUpload">
            <div class="line"></div>
            <i class="iconfont icon-shangchuan" style="font-size:14px"></i>
            <span slot="title">上传周稿</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="/myWriter">
        <template slot="title">
          <!-- <i class="el-icon-caret-bottom"></i> -->
          <span slot="title">数据中心</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="/WriterExamine">
            <div class="line"></div>
            <i class="iconfont icon-kaohe"></i>
            <span slot="title">我的考核</span>
          </el-menu-item>
          <el-menu-item index="/WriterData">
            <div class="line"></div>
            <i class="iconfont icon-data1"></i>
            <span slot="title">我的数据</span>
          </el-menu-item>
          <el-menu-item index="/WriterDayRecord">
            <div class="line"></div>
            <i class="iconfont icon-register"></i>
            <span slot="title">写手日结登记</span>
          </el-menu-item>
          <el-menu-item index="/WriterDaySheet">
            <div class="line"></div>
            <i class="iconfont icon-shuji"></i>
            <span slot="title">写手日结表</span>
          </el-menu-item>
          <el-menu-item index="/WriterWeekRecord">
            <div class="line"></div>
            <i class="iconfont icon-register"></i>
            <span slot="title">写手周结登记</span>
          </el-menu-item>
          <el-menu-item index="/WriterWeekSheet">
            <div class="line"></div>
            <i class="iconfont icon-shuji"></i>
            <span slot="title">写手周结表</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 写手侧边菜单栏数据
      writerMenuList: [
        {
          url: "",
          name: "写手",
          menuId: 1,
          children: [
            {
              url: "/MyWriter",
              name: "我的写手",
              menuId: 1001
            },
            {
              url: "/OrderCenter",
              name: "接单中心",
              menuId: 1001
            },
            {
              url: "/WriterBookInfo",
              name: "写手书籍信息",
              menuId: 1001
            },
            {
              url: "/WriterHighSeas",
              name: "写手公海信息",
              menuId: 1001
            },
            {
              url: "/UploadManuscript",
              name: "每日上传稿件",
              menuId: 1001
            },
            {
              url: "/ManuscriptManage",
              name: "稿费预支及暂压稿",
              menuId: 1001
            }
          ]
        }
      ]
    };
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  }
};
</script>
<style>
.owner_menu .iconfont {
  margin-right: 5px;
}
.owner_menu {
  width: 220px;
  height: 92.5vh;
  background-color: #fff;
}
.el-menu {
  border: none;
}
.iconfont {
  font-size: 20px;
}
.el-submenu__icon-arrow {
  left: 15px;
  font-size: 20px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.el-icon-arrow-down:before {
  content: "\e790";
}
.el-menu-item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}
.el-submenu__title {
  padding-left: 40px !important;
}
.el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
  transform: rotateZ(-90deg) translateX(90px) translateY(-80px);
  margin-top: -2px;
}
.el-menu-item:focus .line {
  display: block;
}
.line {
  width: 5px;
  height: 50px;
  background: #157df8;
  margin-left: -40px;
  margin-right: 35px;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Writer.vue